/**
 * copiaPagina.js — la copia della pagina per una segnalazione (proposta del
 * 28/10/2026, punto 2: «l'istantanea del DOM ripulita, compressa, mostrata dal
 * server in una cornice senza script»; risposta proposta ad Alex, da
 * confermare il 2/11).
 *
 * NON E' UN'IMMAGINE: e' l'HTML della pagina com'era, con lo stile
 * dell'applicazione dentro, e senza niente che si esegua o vada in rete. Una
 * libreria che ridisegna la pagina su una tela sbaglia caratteri e tele e pesa
 * ~200 kB; questa e' qualche riga e si riapre identica.
 *
 * CONTIENE DATI DI PAZIENTI (quello che c'era a schermo, e i valori scritti nei
 * campi): il server la tratta come un allegato clinico. Si tolgono:
 *   - script, noscript, iframe, object, embed, link, meta, base, template;
 *   - ogni attributo on*, e src, srcset, href, action (un indirizzo puo'
 *     portare un gettone nella query: le immagini restano col solo alt);
 *   - le tele (una firma e' una tela): al loro posto un riquadro vuoto;
 *   - i valori dei campi password, sempre;
 *   - il riquadro della segnalazione stessa ([data-segnalazione]).
 * Il server ripete la pulizia per conto suo e la verifica
 * (backend/services/segnalazioni.js): questa non e' l'unica difesa.
 */
const VIA = 'script, noscript, iframe, frame, object, embed, applet, link, meta, base, template, [data-segnalazione]';
const ATTRIBUTI = ['src', 'srcset', 'href', 'action', 'formaction', 'xlink:href', 'poster', 'data', 'ping', 'background'];

/** Il CSS della pagina, dai fogli dello stesso dominio. */
function stile(doc) {
    const parti = [];
    for (const foglio of Array.from(doc.styleSheets || [])) {
        try {
            for (const r of Array.from(foglio.cssRules || [])) parti.push(r.cssText);
        } catch (e) { /* un foglio di un altro dominio non si legge: si salta */ }
    }
    /* image-set() accetta un indirizzo scritto come stringa, senza url(. */
    return parti.join('\n').replace(/@import[^;]*;?/gi, '').replace(/url\s*\([^)]*\)/gi, 'none')
        .replace(/(?:-webkit-)?image-set\s*\(/gi, 'none(');
}

export function copiaPagina(doc = document) {
    const radice = doc.documentElement;
    /* I valori scritti nei campi vivono nelle proprieta', non negli attributi:
       la copia li porta negli attributi, prima di clonare (tranne le password). */
    const originali = Array.from(radice.querySelectorAll('input, textarea, select'));
    const clone = radice.cloneNode(true);
    const copie = Array.from(clone.querySelectorAll('input, textarea, select'));
    copie.forEach((c, i) => {
        const o = originali[i];
        if (!o) return;
        const tipo = (o.getAttribute('type') || '').toLowerCase();
        if (tipo === 'password') { c.removeAttribute('value'); return; }
        if (c.tagName === 'TEXTAREA') c.textContent = o.value;
        else if (c.tagName === 'SELECT') {
            Array.from(c.options).forEach((op, j) => { if (o.options[j]?.selected) op.setAttribute('selected', ''); else op.removeAttribute('selected'); });
        } else if (tipo === 'checkbox' || tipo === 'radio') {
            if (o.checked) c.setAttribute('checked', ''); else c.removeAttribute('checked');
        } else c.setAttribute('value', o.value);
    });
    clone.querySelectorAll(VIA).forEach((n) => n.remove());
    clone.querySelectorAll('canvas').forEach((n) => {
        const posto = doc.createElement('div');
        posto.setAttribute('class', n.getAttribute('class') || '');
        posto.textContent = '[tela non copiata]';
        n.replaceWith(posto);
    });
    clone.querySelectorAll('*').forEach((n) => {
        for (const a of Array.from(n.attributes)) {
            const nome = a.name.toLowerCase();
            if (nome.startsWith('on') || ATTRIBUTI.includes(nome)) n.removeAttribute(a.name);
            else if (nome === 'style' && /url\s*\(|expression\s*\(|javascript:/i.test(a.value)) n.removeAttribute(a.name);
        }
    });
    clone.querySelectorAll('input').forEach((n) => {
        if ((n.getAttribute('type') || '').toLowerCase() === 'password') n.removeAttribute('value');
    });
    /* Lo stile dell'applicazione dentro la copia, al posto dei <link> e dei
       <style> di prima (che doc.styleSheets contiene gia': senza toglierli
       le regole ci sarebbero due volte). */
    clone.querySelectorAll('style').forEach((n) => n.remove());
    const testa = clone.querySelector('head') || clone;
    const s = doc.createElement('style');
    s.textContent = stile(doc);
    testa.appendChild(s);
    return clone.outerHTML;
}
